import createAction from 'utils/redux-helpers/createAction';

const handler = (state, { name }) => state.setIn(['loading', name], true);

export const startLoading = createAction({
  action: ['startLoading', 'name'],
  handler,
});
